/* Salty Dogs Crew · mar al sol en WebGL1: fondo de New Drop y de colecciones (reemplaza el video 852x480).
   Una textura de ruido 256x256 periódica generada acá (altura, gradiente, grano fino) se lee en 6 escalas
   con crestas apaisadas y perspectiva; la pendiente da el color (rampa medida en el video) y, donde mira
   al sol dentro de una franja diagonal, los destellos: masa lechosa con chispas adentro, como el video.
   Uso: <div class="sd-agua-wrap"><canvas class="sd-agua" data-sd-agua></canvas>…</div>
   Atributos: data-scale (0,5; 0,75 en celular), data-fps (30), data-static, data-deep, data-light,
   data-observe (selector: qué elemento tiene que estar en pantalla para animar; por defecto el canvas). */
(function () {
  'use strict';
  var VS = 'attribute vec2 p;varying vec2 v;void main(){v=p*0.5+0.5;gl_Position=vec4(p,0.,1.);}';
  var FS = [
    '#ifdef GL_FRAGMENT_PRECISION_HIGHP\nprecision highp float;\n#else\nprecision mediump float;\n#endif', /* fp16 cuantiza las coordenadas finas en GPU de celular */
    'varying vec2 v;uniform vec2 r;uniform sampler2D n;',
    'uniform vec2 o0,o1,o2,o3,o4,o5,ph;uniform vec3 bc;uniform float tw,tw2,lb;', /* offsets ya envueltos a [0,1) en JS */
    'uniform vec3 C0,C1,C2,CH;const vec3 C3=vec3(0.945,0.965,1.0);',
    'vec2 rot(vec2 p,float a){float c=cos(a),s=sin(a);return vec2(c*p.x-s*p.y,s*p.x+c*p.y);}',
    'void main(){',
    '  vec2 s=vec2((v.x-0.5)*r.x/r.y,v.y);',
    '  float d=1.0/(1.0-0.42*v.y);',                               /* perspectiva: arriba más chico */
    '  vec2 w=vec2(s.x*d,2.0*(d-1.0)/0.42-1.7);',                   /* mundo centrado (mediump) */
    '  vec4 nP=texture2D(n,w*vec2(0.09,0.15)+o5,lb);',              /* manchones lentos */
    '  vec4 n0=texture2D(n,rot(w*vec2(0.60,1.0),0.10)*0.42+o0,lb);',/* mar de fondo */
    '  vec4 n3=texture2D(n,rot(w*vec2(0.80,1.0),-0.50)*6.0+o3+0.08*(n0.gb-0.5),lb);', /* finas, rápidas */
    '  vec2 ch=n3.gb-0.5;',                                          /* las finas sacuden a las medias: picado vivo */
    '  vec4 n1=texture2D(n,rot(w*vec2(0.75,1.0),-0.18)*1.30+o1+0.05*ch,lb);',/* ondas medias */
    '  vec4 n2=texture2D(n,rot(w*vec2(0.80,1.0),0.30)*3.0+o2+0.05*(n0.gb-0.5)+0.06*ch,lb);',  /* picadas */
    '  vec2 u4=rot(w*vec2(1.0,0.75),0.6)*1.4+o4;',                                 /* grano (canal A): nítido para chispas, borroso para el halo */
    '  vec4 n4=texture2D(n,u4,lb);float hz=texture2D(n,u4,lb+1.0).a;',
    '  vec2 g0=n0.gb-0.5,g1=n1.gb-0.5,g2=n2.gb-0.5,g3=n3.gb-0.5;',
    /* dos crestas largas afiladas (exp(q(sin-1))) con pendiente analítica */
    '  vec2 k1=vec2(0.35,2.6),k2=vec2(-0.6,4.1);float a1=dot(w,k1)+ph.x,a2=dot(w,k2)+ph.y;',
    '  vec2 gw=k1*(0.05*cos(a1)*exp(1.5*(sin(a1)-1.0)))+k2*(0.022*cos(a2)*exp(1.5*(sin(a2)-1.0)));',
    /* titileo: dos senos rápidos no conmensurables con fase propia por chispa (capas finas) que sacuden la pendiente */
    '  float s1=sin(6.2832*(n3.r+tw)),s2=sin(6.2832*(2.0*n2.r+tw2));float twk=0.5*s1+0.5*s2;vec2 jit=0.10*vec2(s1,s2);',
    /* color base por pendiente vertical: cara al cielo clara, cara a cámara oscura.
       Sigmoide suave (no satura) y rampa continua entre 3 colores + variación lenta de tono: sin manchas planas */
    '  float z=4.6*(0.45*g0.y+1.0*g1.y+0.9*g2.y+0.7*g3.y)+0.3*(n0.r-0.5)+0.25*(nP.r-0.5)+3.0*gw.y+6.0*jit.y+3.0*jit.x;',
    '  float l=0.5+0.5*z*0.75*inversesqrt(1.0+0.5625*z*z);',
    '  vec3 col=mix(C0,C2,l);col=mix(col,C1,2.2*l*(1.0-l));col*=0.92+0.16*nP.r;',
    /* franja diagonal (arriba-derecha a abajo-izquierda) que deriva, moteada por nP */
    '  vec2 bs=s-bc.xy,ax=vec2(-0.5145,-0.8575),nr=vec2(-ax.y,ax.x);',
    '  float ac=dot(bs,nr)*bc.z,al=dot(bs,ax);',
    '  float mask=exp(-ac*ac*7.0)*(0.3+1.4*nP.r),mk=clamp(mask,0.0,1.0);',
    /* destellos tipo Cox-Munk: la pendiente objetivo crece al alejarse de la franja */
    '  vec2 tg=nr*ac*0.7+ax*al*0.15+0.16*(nP.a-0.5);',
    '  vec2 sC=g0*1.1+g1*1.0+g2*0.6+gw*2.0+jit,sF=sC+g2*0.3+g3*0.8+0.3*jit;',
    '  vec2 dC=sC-tg,dF=(sF-tg)*vec2(1.8,1.0);float qC=dot(dC,dC),qF=dot(dF,dF);',
    /* dentro de la franja manda lo lechoso: patch y halo anchos (el halo se ensancha con mk) y un núcleo
       continuo (core2) que llena el centro de blanco; los trozos (bits, con grano medio borroso para que se
       fusionen) y las chispas se atenúan afuera de la franja para que lejos del sol queden solo puntitos */
    '  float patch=(1.0-smoothstep(0.0,0.12,qC))*(0.78+0.6*(n3.r-0.5)+0.35*(n2.r-0.5))*(0.12+0.8*mask)*(0.75+0.45*twk);',
    '  float halo=(1.0-smoothstep(0.02,0.16+0.35*mk,qF))*(0.2+0.8*mask)*(0.7+0.6*hz)*(0.85+0.3*twk);',
    '  float core=1.0-smoothstep(0.006,0.030,qF),core2=1.0-smoothstep(0.015,0.08+0.10*mk,qF);',
    '  float bits=core*smoothstep(0.50-0.15*twk,0.72-0.15*twk,0.3*n4.a+0.7*hz)*(0.2+0.8*mk);', /* trozos duros e irregulares */
    '  float th=0.72-0.2*mk+0.07*twk;',
    '  float spark=smoothstep(th,th+0.04,n4.a)*(1.0-smoothstep(0.02,0.07,qF))*(0.15+0.85*mk);', /* chispas */
    '  col=mix(col,CH,clamp(0.85*patch+0.6*halo,0.0,1.0));',
    '  col=mix(col,C3,clamp(0.8*bits+0.85*mk*core2,0.0,1.0));col=mix(col,vec3(1.0),spark);',
    '  gl_FragColor=vec4(col,1.0);}'].join('\n');

  /* rato libre: requestIdleCallback con timeout (el de 500 ms caía en plena carga del tema; con rAF
     constante en la página el idle no llega nunca y manda el timeout, por eso los pasos cortos usan uno
     corto); sin él (Safari) esperamos al evento load y un poco más, nunca en medio del parseo */
  function idle(f, ms) {
    if (window.requestIdleCallback) return requestIdleCallback(f, { timeout: ms || 2500 });
    var go = function () { setTimeout(f, ms || 200); };
    if (document.readyState === 'complete') go(); else window.addEventListener('load', go);
  }

  var N = 256, noise = null, noiseWait = [];
  function makeNoise(done) {          /* R altura, G/B gradiente (3 sigma = 1), A grano fino; semilla fija.
                                         Se arma de a una octava por rato libre (5 pasos cortos) y se comparte entre canvas */
    if (noise) return done();
    noiseWait.push(done);
    if (noiseWait.length > 1) return; /* ya en marcha: avisamos a todos al terminar */
    var seed = 7, rnd = function () { seed = (seed * 1664525 + 1013904223) >>> 0; return seed / 4294967296; };
    var sm = function (t) { return t * t * t * (t * (t * 6 - 15) + 10); };
    var h = new Float32Array(N * N), fine = new Float32Array(N * N);
    var i0 = new Int32Array(N), c1 = new Int32Array(N), su = new Float32Array(N);
    function octave(out, f, amp) {    /* una octava de value noise periódico separable: f celdas, amplitud amp */
      var lat = new Float32Array(f * f), i, x, y, u, j0, sv, r0, r1, a, b;
      for (i = 0; i < f * f; i++) lat[i] = rnd() - 0.5;
      for (x = 0; x < N; x++) { u = x / N * f; i0[x] = Math.floor(u); c1[x] = (i0[x] + 1) % f; su[x] = sm(u - i0[x]); }
      for (y = 0; y < N; y++) {
        u = y / N * f; j0 = Math.floor(u); sv = sm(u - j0); r0 = j0 * f; r1 = (j0 + 1) % f * f;
        for (x = 0; x < N; x++) {
          a = lat[r0 + i0[x]] * (1 - su[x]) + lat[r0 + c1[x]] * su[x];
          b = lat[r1 + i0[x]] * (1 - su[x]) + lat[r1 + c1[x]] * su[x];
          out[y * N + x] += amp * (a * (1 - sv) + b * sv);
        }
      }
    }
    function pack() {                 /* a RGBA de 8 bits; 1.32, 1.42 y 12.84 normalizan esta semilla */
      var tex = new Uint8Array(N * N * 4), i, x, y;
      var c8 = function (v) { return Math.max(0, Math.min(255, Math.round(127.5 + 127.5 * v))); };
      for (y = 0; y < N; y++) for (x = 0; x < N; x++) {
        i = y * N + x;
        tex[i * 4] = c8(h[i] * 1.32); tex[i * 4 + 3] = c8(fine[i] * 1.42);
        tex[i * 4 + 1] = c8((h[y * N + (x + 1) % N] - h[y * N + (x + N - 1) % N]) * 12.84);
        tex[i * 4 + 2] = c8((h[(y + 1) % N * N + x] - h[(y + N - 1) % N * N + x]) * 12.84);
      }
      return tex;
    }
    var steps = [[h, 4, 1], [h, 8, 0.55], [h, 16, 0.3], [fine, 24, 1], [fine, 40, 0.5]], k = 0;
    (function step() {
      if (k < steps.length) { octave(steps[k][0], steps[k][1], steps[k][2]); k++; idle(step, 120); return; }
      noise = pack();
      var w = noiseWait, j; noiseWait = [];
      for (j = 0; j < w.length; j++) w[j]();
    })();
  }
  function hex(s, def) {              /* '#rrggbb' -> [r, g, b] en 0..1 */
    var m = /^#?([0-9a-f]{6})$/i.exec(s || ''), n = m ? parseInt(m[1], 16) : def;
    return [(n >> 16 & 255) / 255, (n >> 8 & 255) / 255, (n & 255) / 255];
  }
  var reduce = matchMedia('(prefers-reduced-motion: reduce)'), all = [];

  function init(canvas) {
    if (!canvas || canvas.__sdAgua) return canvas && canvas.__sdAgua;
    var st = { canvas: canvas, gl: null, ready: false, started: false, raf: 0, last: 0, tDrawn: 0, seen: true, lost: false, dead: false, frames: 0, ms: 0, w: 0, h: 0, cssW: 0, cssH: 0, dirty: false };
    canvas.__sdAgua = st; all.push(st);
    var ds = canvas.dataset, fps = +ds.fps || 30, isStatic = ds.static != null, scale = +ds.scale || 0, U = {}, pr = null, par = null, pollTok = 0;
    var seenEl = (ds.observe && document.querySelector(ds.observe)) || canvas;   /* capa fija: se mira <main>, no el canvas */
    var deep = hex(ds.deep, 0x48698d), light = hex(ds.light, 0xa5b5cc);   /* medidos en el video */
    var t0 = performance.now() - Math.random() * 1e6;                   /* cada canvas arranca distinto */

    function fail() {                 /* sin WebGL: queda el degradado del CSS, sin ruido en consola */
      st.dead = true; stop();
      if (canvas.parentElement) canvas.parentElement.classList.add('sd-agua--sin-gl');
      canvas.hidden = true;
    }
    function start() {                /* una sola vez, cuando el canvas se acerca a la pantalla y sobra tiempo */
      if (st.started) return; st.started = true;
      if (st.io2) { st.io2.disconnect(); st.io2 = null; }
      idle(function () { requestAnimationFrame(function () { if (!st.dead && !st.gl && !setup()) fail(); }); });
    }
    function setup() {                /* contexto y programa (también tras contextrestored); el link se consulta después, por rAF */
      var gl = st.gl, o = { alpha: false, antialias: false, depth: false, stencil: false, powerPreference: 'low-power' };
      try { gl = gl || canvas.getContext('webgl', o); } catch (e) { gl = null; }
      if (!gl) return false;
      st.gl = gl; st.ready = false;
      /* un contexto recién creado y sin dibujar se ve negro: lo pintamos del azul medio en este mismo rAF */
      gl.clearColor((deep[0] + light[0]) / 2, (deep[1] + light[1]) / 2, (deep[2] + light[2]) / 2, 1); gl.clear(gl.COLOR_BUFFER_BIT);
      var sh = function (t, src) { var s = gl.createShader(t); gl.shaderSource(s, src); gl.compileShader(s); return s; };
      pr = gl.createProgram(); gl.attachShader(pr, sh(gl.VERTEX_SHADER, VS)); gl.attachShader(pr, sh(gl.FRAGMENT_SHADER, FS)); gl.linkProgram(pr);
      par = gl.getExtension('KHR_parallel_shader_compile');
      makeNoise(function () {});      /* en ratos libres, mientras el driver compila */
      poll(++pollTok, 2);             /* sin la extensión: dos frames de aire antes de consultar el link */
      return true;
    }
    function poll(tok, wait) {        /* espera por rAF (nunca sincrónico) a que programa y ruido estén listos */
      if (tok !== pollTok || st.dead || st.lost || st.ready) return;
      var ok = par ? st.gl.getProgramParameter(pr, par.COMPLETION_STATUS_KHR) : wait <= 0;
      if (ok && noise) finish(); else requestAnimationFrame(function () { poll(tok, wait - 1); });
    }
    function finish() {               /* programa listo (o no): buffers, uniforms, textura y primer frame */
      var gl = st.gl;
      if (!gl.getProgramParameter(pr, gl.LINK_STATUS)) return fail();
      gl.useProgram(pr);
      gl.bindBuffer(gl.ARRAY_BUFFER, gl.createBuffer());
      gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);   /* un triángulo */
      var lp = gl.getAttribLocation(pr, 'p'); gl.enableVertexAttribArray(lp); gl.vertexAttribPointer(lp, 2, gl.FLOAT, false, 0, 0);
      'r n o0 o1 o2 o3 o4 o5 ph bc tw tw2 lb C0 C1 C2 CH'.split(' ').forEach(function (k) { U[k] = gl.getUniformLocation(pr, k); });
      gl.bindTexture(gl.TEXTURE_2D, gl.createTexture());
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, N, N, 0, gl.RGBA, gl.UNSIGNED_BYTE, noise);
      gl.generateMipmap(gl.TEXTURE_2D);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_LINEAR);
      gl.uniform1i(U.n, 0);
      gl.uniform3fv(U.C0, deep); gl.uniform3fv(U.C2, light);
      gl.uniform3f(U.C1, (deep[0] + light[0]) / 2, (deep[1] + light[1]) / 2, (deep[2] + light[2]) / 2 + 0.02);
      gl.uniform3f(U.CH, light[0] * 0.5 + 0.5, light[1] * 0.5 + 0.5, light[2] * 0.4 + 0.6);
      st.w = st.h = 0; st.dirty = true; st.ready = true;
      if (!st.ro) measure();
      requestAnimationFrame(function () { update(); });   /* primer frame (y el canvas.width) en otra tarea */
    }
    function measure(W, H) {          /* tamaño CSS: lo avisa el ResizeObserver; sin él, se lee acá (una vez y en resize) */
      st.cssW = W == null ? canvas.clientWidth : W; st.cssH = H == null ? canvas.clientHeight : H; st.dirty = true;
    }
    function resize() {               /* resolución interna: 0,5 de los px CSS (0,75 en celular); no lee layout */
      st.dirty = false;
      var W = st.cssW, H = st.cssH, gl = st.gl;
      if (!W || !H) return;
      var sc = Math.min(1, scale || (W < 768 ? 0.75 : 0.5), 1280 / W);
      var w = Math.max(2, Math.round(W * sc)), h = Math.max(2, Math.round(H * sc));
      /* histéresis: la barra de URL del celular cambia el alto de a píxeles y el estirado CSS tapa un 5 % */
      if (st.w && Math.abs(w - st.w) < 0.05 * st.w && Math.abs(h - st.h) < 0.05 * st.h) return;
      canvas.width = st.w = w; canvas.height = st.h = h;
      gl.viewport(0, 0, w, h); gl.uniform2f(U.r, w, h);
      gl.uniform1f(U.lb, Math.max(0, Math.log(sc / 0.5) / Math.LN2));   /* sesgo de mipmap: mismo detalle a cualquier escala */
    }
    var fr = function (x) { return x - Math.floor(x); };
    function draw(now) {
      if (st.dirty) resize();
      if (!st.w) return;
      st.tDrawn = now;                /* instante del último frame: si se congela, se redibuja este mismo */
      var gl = st.gl, t = (now - t0) / 1000, ax = Math.min(1, st.w / st.h / 1.76);   /* todo lo que entra al shader queda acotado */
      gl.uniform2f(U.o0, fr(0.004 * t), fr(-0.016 * t));
      gl.uniform2f(U.o1, fr(0.035 * t), fr(-0.080 * t));
      gl.uniform2f(U.o2, fr(-0.20 * t), fr(-0.29 * t));
      gl.uniform2f(U.o3, fr(0.40 * t), fr(-0.55 * t));
      gl.uniform2f(U.o4, fr(-0.24 * t), fr(-0.42 * t));
      gl.uniform2f(U.o5, fr(0.003 * t), fr(-0.006 * t));
      gl.uniform2f(U.ph, fr(-0.11 * t) * 6.2832, fr(0.17 * t) * 6.2832);
      /* la franja deriva con senos no conmensurables (nunca repite) y se angosta en pantallas angostas */
      gl.uniform3f(U.bc, (0.22 + 0.10 * Math.sin(t * 0.11) + 0.05 * Math.sin(t * 0.037 + 1)) * ax, 0.5 + 0.12 * Math.sin(t * 0.073 + 2), 1 / Math.sqrt(ax));
      gl.uniform1f(U.tw, fr(t * 4.5)); gl.uniform1f(U.tw2, fr(t * 1.4));
      gl.drawArrays(gl.TRIANGLES, 0, 3);
    }
    function tick(now) {
      st.raf = 0;
      if (!canvas.isConnected) return destroy();
      st.raf = requestAnimationFrame(tick);
      if (now - st.last < 1000 / fps - 2) return;        /* limitado a data-fps */
      if (st.last && ++st.frames > 5) st.ms += (now - st.last - st.ms) / Math.min(st.frames - 5, 30);   /* ms/frame */
      st.last = now; draw(now);
    }
    function stop() { if (st.raf) cancelAnimationFrame(st.raf); st.raf = st.last = 0; }
    function update() {               /* decide si animar, dibujar un solo frame o nada */
      if (st.dead || st.lost || !st.ready) return;
      var show = st.seen && !document.hidden, anim = show && !isStatic && !(reduce && reduce.matches);
      if (anim && !st.raf) tick(performance.now());      /* primer frame ya, en este mismo rAF */
      if (!anim) {
        stop();
        /* quieto (static / reducir movimiento): el tiempo queda congelado y solo se redibuja si cambió el tamaño
           o nunca se dibujó; volver a pantalla o cambiar de pestaña no cambia la imagen */
        if (show && (st.dirty || !st.tDrawn)) draw(st.tDrawn || performance.now());
      }
    }
    function onResize() { if (!st.ro) measure(); if (!st.raf) update(); }
    function destroy() {
      stop(); st.dead = true;
      if (st.io) st.io.disconnect(); if (st.io2) st.io2.disconnect(); if (st.ro) st.ro.disconnect();
      window.removeEventListener('resize', onResize);
      document.removeEventListener('visibilitychange', update);
      if (reduce && reduce.removeEventListener) reduce.removeEventListener('change', update);
      all.splice(all.indexOf(st), 1);
    }
    st.destroy = destroy;

    /* contexto perdido: Chrome compone el canvas blanco opaco, así que se esconde y queda el degradado del wrap */
    canvas.addEventListener('webglcontextlost', function (e) { e.preventDefault(); st.lost = true; st.ready = false; stop(); canvas.style.visibility = 'hidden'; });
    canvas.addEventListener('webglcontextrestored', function () { st.lost = false; canvas.style.visibility = ''; if (!setup()) fail(); });
    if (window.IntersectionObserver) {
      st.io = new IntersectionObserver(function (es) { st.seen = es[es.length - 1].isIntersecting; update(); }, { rootMargin: '80px' });
      st.io.observe(seenEl);
      /* el contexto recién se crea cuando el canvas está a menos de 1200 px: quien no llega a New Drop no paga nada,
         y quien scrollea rápido lo encuentra ya dibujando */
      st.io2 = new IntersectionObserver(function (es) { if (es[es.length - 1].isIntersecting) start(); }, { rootMargin: '1200px' });
      st.io2.observe(seenEl);
    } else start();
    if (window.ResizeObserver) {      /* guarda el tamaño CSS (nada de clientWidth por frame) y redibuja si no está animando */
      var pend = 0;
      st.ro = new ResizeObserver(function (es) {
        var b = es[es.length - 1].contentRect; measure(b.width, b.height);
        pend = pend || requestAnimationFrame(function () { pend = 0; if (!st.raf) update(); });
      });
      st.ro.observe(canvas);
    } else window.addEventListener('resize', onResize);
    document.addEventListener('visibilitychange', update);
    if (reduce && reduce.addEventListener) reduce.addEventListener('change', update);   /* Safari viejo no lo tiene */
    return st;
  }

  function initAll() {                /* también limpia los canvas que el editor de temas sacó del DOM */
    var cs = document.querySelectorAll('canvas[data-sd-agua]'), i;
    for (i = 0; i < cs.length; i++) init(cs[i]);
    for (i = all.length - 1; i >= 0; i--) if (!all[i].canvas.isConnected) all[i].destroy();
    if (cs.length && !noise) idle(function () { makeNoise(function () {}); }, 4000);   /* la textura, en un rato libre después de cargar */
  }
  window.SaltyAgua = { init: init, initAll: initAll };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:unload', initAll);
})();
